import PropTypes from "prop-types";
import React from "react";
import classnames from "classnames";
import styles from "./designer-image.css";

function DesignerImage({ designer }) {
    return (
        <div className={styles.designerCard}>
            {designer.image_url && (
                <a href={designer.designer_url}>
                    <img
                        src={designer.image_url}
                        alt={designer.designer_name}
                        className={classnames(styles.designerImage)}
                    />
                </a>
            )}
            <a href={designer.designer_url} className={styles.designerName}>
                {designer.designer_name}
            </a>
        </div>
    );
}

DesignerImage.propTypes = {
    designer: PropTypes.object.isRequired,
};

export default DesignerImage;
